import type { Claim } from "@rumble-it/common-lib/types/models/Claim.interface";
import type { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";

function mockClaim(
  id: string,
  licensePlate: string,
  brand: string,
  model: string,
  driverName: string,
): Claim {
  return {
    "@type": "ClaimOutput",
    id,
    claimNumber: null,
    damageNumber: null,
    calculations: null,
    status: null,
    invoices: null,
    sourceType: null,
    dossier: {
      id,
      vehicle: {
        licensePlate: { identifier: licensePlate },
        brand,
        model,
      },
      driver: { fullName: driverName },
    } as unknown as Dossier,
  };
}

export const herstelKanbanMockData: Record<string, Claim[]> = {
  calculatie_geaccordeerd: [
    mockClaim("h-001", "JXF-31-L", "Volkswagen", "Golf", "J. de Vries"),
    mockClaim("h-002", "JSJ-63-V", "BMW", "X5 xDrive50e", "M. Janssen"),
  ],
  voertuig_bij_hersteller: [
    mockClaim("h-003", "JVD-30-K", "Toyota", "Corolla", "S. Bakker"),
    mockClaim("h-004", "JSV-18-B", "Audi", "Q3 Sportback", "H. Willems"),
    mockClaim("h-005", "R-655-PD", "Mercedes-Benz", "AMG C 43", "L. Mulder"),
  ],
  voertuig_hersteld: [
    mockClaim("h-006", "KDJ-59-X", "Peugeot", "3008", "R. Smit"),
  ],
  terug_bij_bestuurder: [
    mockClaim("h-007", "KDJ-16-R", "Renault", "Austral", "A. van Dam"),
    mockClaim("h-008", "JXD-47-T", "Ford", "Explorer", "E. Visser"),
  ],
};
